// React
import { Link, useHistory } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';

// Containers Injections
import { ProposalsInjection } from '../../containers/proposalsInjection';

// View
import { ProposalsListPage } from './view';

export const ProposalList = () => {
  const [id, setId] = useState(null);

  const {
    success,
    deleteProposal,
    loadingByAssociates,
    proposalsAssociates,
    getProposalsByAssociate,
  } = ProposalsInjection();

  const history = useHistory();

  const handleDelete = (id) => {
    deleteProposal(id);
  };

  const handleEdit = useCallback(
    (values) => {
      const { hashid: idProposal } = values;
      history.push(`/propostas/view/${idProposal}`);
    },
    [history]
  );

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Número</span>,
      sortable: true,
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link
                to={`/propostas/view/${cell.hashid}`}
                className="currency_name"
              >
                {cell.number}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Categoria</span>,
      id: 'name2',
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Plano</span>,
      id: 'name3',
      selector: (row) => row.plan,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Mensalidade</span>,
      id: 'name4',
      selector: (row) => row.price,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 ">Validade</span>,
      id: 'name5',
      selector: (row) => row.valid_until,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Situação</span>,
      id: 'name1',
      selector: (row) => row.status,
      sortable: true,
    },
  ];

  useEffect(() => {
    if (id) {
      getProposalsByAssociate(id);
    }
  }, [getProposalsByAssociate, id, success]);

  useEffect(() => {
    const full_url = document.URL; // Get current url
    const url_array = full_url.split('/'); // Split the string into an array with / as separator
    const last_segment = url_array[url_array.length - 1];
    setId(last_segment);
  }, []);

  return (
    <ProposalsListPage
      id={id}
      columns={columns}
      history={history}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      loading={loadingByAssociates}
      proposalsAssociates={proposalsAssociates || []}
    />
  );
};
